export const CustomerGroup = Object.freeze({
    Gold: 1,
    Internal: 2,
    Vip: 3,
    Occasion: 4,
    Exclusive: 5
  });
